export function isCourtDrive() {
  return /courtdrive/i.test(window.location.hostname);
}

export function isProd() {
  return !/dev.azk.io/i.test(window.location.hostname);
}



/** WEBPACK FOOTER **
 ** ./src/util/globalUtils.js
 **/